export default "__VITE_ASSET__10033993__"